import React from 'react'
import { Layout, Typography } from "antd";

const CustomHeader = () => {
    const { Header } = Layout;
    const { Title } = Typography;
  return (
    <Header className="top-header">
    <Title level={2} className="title">
      Online Medical Records Request Portal
    </Title>
  </Header>
  )
}

export default CustomHeader;